import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard  {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }


  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    if (this.authService.isOperatorAccountLandingUser) {
      void this.router.navigate(['/choose-account']);
      return false;
    }

    this.router.navigate(['/dashboard']);
    return false;
  }
}
